<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formClick" :formData="formData"></FORM>
    <table-page ref="childTable"   @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData"></UPDATE>
  </div>
</template>

<script>

import UPDATE from "@/components/page/update.vue";
import tablePage from "@/components/page/table.vue";
import FORM from "@/components/page/form.vue";
import URL from "@/views/newmis36/util/url";
import { dataChange } from '@/utils/dataChange';

const statusMap = { 1: true, 2: false};
let systemMap = {};
let platformMap = {};
let channelMap = {};

export default {
  components: {
    FORM,
    UPDATE,
    tablePage
  },
  created () {
    this.statusOptionList = [
      {key: 1, value: window.$t("txmis.bt.enable")},
      {key: 2, value: window.$t("txmis.bt.disable")}
    ];
    this.getOptions();
  },
  mounted(){
    // Query Form
    this.$set(this.formData.cols[1], "optionList", this.platformOptionList);
    this.$set(this.formData.cols[2], "optionList", this.systemOptionList);
    this.$set(this.formData.cols[3], "optionList", this.statusOptionList);
    // Add/Update Modal
    this.$set(this.updateData.cols[1], "optionList", this.platformOptionList);
    this.$set(this.updateData.cols[3], "optionList", this.webChannelOptionList);
    this.$set(this.updateData.cols[4], "optionList", this.mChannelOptionList);
    this.$set(this.updateData.cols[5], "optionList", this.appChannelOptionList);
    this.$forceUpdate();
  },
  methods: {
    formClick (clickName, data) {
      // console.log("formClick: ", clickName, data);
      if (clickName === "init") {
        this.$refs.childTable.defaultQueryData(this.queryData);
      } else if (clickName === "query") {
        this.queryData = data;
        if (this.queryData.system) {
          this.queryData.system = systemMap[this.queryData.system];
        }
        if (this.queryData.platform) {
          this.queryData.platform = platformMap[this.queryData.platform];
        }
        if (this.queryData.status !== undefined) {
          this.queryData.status = statusMap[this.queryData.status];
        }
        this.$refs.childTable.defaultGetData(this.queryData);
      } else if (clickName === "add") {
        this.modalData = {};
        this.$refs.childUpdate.open(this.modalData);
      }
    },
    bthClick (clickName, row) {
      // console.log("bthClick: ", clickName, row);
      if (clickName === "update") {
        this.modalData = {};
        this.modalData.id = row.id;
        this.modalData.platform = row.platform.id;
        this.modalData.url = row.url;
        this.modalData.webChannel = row.channels.filter(el => el.system === "WEB") ? row.channels.filter(el => el.system === "WEB").map(el => el.id) : null;
        this.modalData.mChannel = row.channels.filter(el => el.system === "M") ? row.channels.filter(el => el.system === "M").map(el => el.id) : null;
        this.modalData.appChannel = row.channels.filter(el => el.system === "APP") ? row.channels.filter(el => el.system === "APP").map(el => el.id) : null;
        this.modalData.sort = row.sort;
        this.modalData.isActive = row.isActive;
        // console.log("Modal: ", this.modalData);
        this.$refs.childUpdate.open(this.modalData);
      } else if (clickName === "delete") {
        if (!row.id) this.$message.error(window.$t("txmis.socialMedia.message.invalid"));
        this.delete(row.id)
      } else if (clickName === "activate") {
        if (!row.id) this.$message.error(window.$t("txmis.socialMedia.message.invalid"));
        this.activate(row.id)
      }
    },
    submit (payload) {
      // console.log("submit: ", payload);
      let submitData = {};
      let channelIds = [];
      if (payload.id) submitData.id = payload.id;
      submitData.url = payload.url;
      submitData.isActive = payload.isActive;
      if (payload.sort) submitData.sort = payload.sort;
      if (payload.platform) submitData.platformId = payload.platform;
      if (payload.webChannel) channelIds.push(payload.webChannel);
      if (payload.mChannel) channelIds.push(payload.mChannel);
      if (payload.appChannel) channelIds.push(payload.appChannel);
      if (channelIds.flatMap(el => el).length === 0) {
        this.$message.error(window.$t("txmis.socialMedia.message.channelNotEmpty"));
      } else {
        submitData.channelIds = channelIds.flatMap(el => el);
        // console.log("Submit data: ", submitData);
        this.saveOrUpdate(submitData);
      }
    },
    getOptions () {
      dataChange(URL.socialMedia.account.options, {}, (res) => {
        if(res.code === 0) {
          // console.log(res);
          let systemOptions = res.result ? res.result.systems : {};
          let channelOptions = res.result ? res.result.channels : {};
          let platformOptions = res.result ? res.result.platforms : {};

          let webChannelOptions = channelOptions ? channelOptions.filter(el => el.system === "WEB") : {};
          let mChannelOptions = channelOptions ? channelOptions.filter(el => el.system === "M") : {};
          let appChannelOptions = channelOptions ? channelOptions.filter(el => el.system === "APP") : {};

          systemMap = systemOptions;
          platformOptions.forEach(el => {platformMap[el.id] = el.platform});

          let webChannelMap = {};
          let mChannelMap = {};
          let appChannelMap = {};
          channelOptions.forEach(el => {channelMap[el.id] = el.channel}); // Master map
          webChannelOptions.forEach(el => {webChannelMap[el.id] = el.channel});
          mChannelOptions.forEach(el => {mChannelMap[el.id] = el.channel});
          appChannelOptions.forEach(el => {appChannelMap[el.id] = el.channel});

          for (const [key, value] of Object.entries(systemMap)) {
            this.systemOptionList.push({key: parseInt(key, 10), value: value});
          }
          for (const [key, value] of Object.entries(platformMap)) {
            this.platformOptionList.push({key: parseInt(key, 10), value: value});
          }
          for (const [key, value] of Object.entries(channelMap)) {
            this.channelOptionList.push({key: parseInt(key, 10), value: value});
          }
          for (const [key, value] of Object.entries(webChannelMap)) {
            this.webChannelOptionList.push({key: parseInt(key, 10), value: value});
          }
          for (const [key, value] of Object.entries(mChannelMap)) {
            this.mChannelOptionList.push({key: parseInt(key, 10), value: value});
          }
          for (const [key, value] of Object.entries(appChannelMap)) {
            this.appChannelOptionList.push({key: parseInt(key, 10), value: value});
          }
        }
      }, (err) => {this.errorHandle(err)})
    },
    saveOrUpdate (data) {
      let url = URL.socialMedia.account.add;
      if (data.id) {
        url = URL.socialMedia.account.update;
      }
      dataChange(url, data, (res) => {
        // console.log(res);
        if (res.code === 0) {
          if(res.result) {
            this.$message.success(window.$t("txmis.socialMedia.message.success"));
          } else {
            this.$message.error(window.$t("txmis.socialMedia.message.fail") +
              window.$t("txmis.socialMedia.message.duplicate"));
          }
          this.$refs.childUpdate.close();
          this.modalData = {};
        }
      }, (err) => {this.errorHandle(err)}, "POST", "json").then(() => {
        this.$refs.childUpdate.close();
        this.refreshTable();
      });
    },
    activate (id) {
      // console.log("activate: ", id);
      let url = URL.socialMedia.account.activate + "/" + id;
      dataChange(url, {}, (res) => {
        // console.log(res);
        if (res.code === 0) {
          this.successHandle(res);
        }
      }, (err) => {this.errorHandle(err)}).then(() => {
        this.refreshTable();
      });
    },
    delete (id) {
      // console.log("delete: ", id);
      let url = URL.socialMedia.account.delete + "/" + id;
      dataChange(url, {}, (res) => {
        console.log(res);
        if (res.code === 0) {
          this.successHandle(res);
        }
      }, (err) => {this.errorHandle(err)}).then(() => {
        this.refreshTable();
      });
    },
    successHandle (success) {
      if(success.result) {
        this.$message.success(window.$t("txmis.socialMedia.message.success"));
      } else {
        this.$message.error(window.$t("txmis.socialMedia.message.fail"));
      }
    },
    errorHandle(error) {
      const errorMessage =
        (error.response && error.response.data && error.response.data.message) ||
        window.$t("txmis.socialMedia.message.unknown");
      this.$message.error(
        window.$t("txmis.socialMedia.message.fail") + ": " + errorMessage
      );
    },
    refreshTable() {
      this.$refs.childTable.defaultGetData(this.queryData);
      this.$forceUpdate();
    }
  },
  data() {
    return {
      // OptionList data
      statusOptionList: [],
      systemOptionList: [],
      platformOptionList: [],
      channelOptionList: [],
      webChannelOptionList: [],
      mChannelOptionList: [],
      appChannelOptionList: [],
      // Data
      queryData:{},
      modalData:{},
      // Query form
      formData: {
        hasLable : true,
        initClickName: "init",
        cols:[
          { title: window.$t("txmis.socialMedia.account.form.channel.label"), field: "channel" },
          { title: window.$t("txmis.socialMedia.account.form.platform.label"), field: "platform", type: 2, optionList: [] },
          { title: window.$t("txmis.socialMedia.account.form.system.label"), field: "system", type: 2, optionList: [],
              placeholder: window.$t("txmis.socialMedia.account.form.system.placeholder") },
          { title: window.$t("txmis.socialMedia.account.form.status.label"), field: "status", type: 2, optionList: [],
              placeholder: window.$t("txmis.socialMedia.account.form.status.placeholder") },
          { title: window.$t("txmis.socialMedia.account.form.fromTime.label"), field: "fromTime",type: 5, format: "yyyy-MM-dd HH:mm:ss",
              placeholder: window.$t("txmis.socialMedia.account.form.fromTime.placeholder") },
          { title: window.$t("txmis.socialMedia.account.form.toTime.label"), field: "toTime",type: 5, format: "yyyy-MM-dd HH:mm:ss",
              placeholder: window.$t("txmis.socialMedia.account.form.toTime.placeholder") },
          { buttonLabel: window.$t("txmis.bt.query"), click: "query"},
          { buttonLabel: window.$t("txmis.bt.add"), click: "add"}
        ]
      },
      // Table
      pageData: {
        queryUrl: URL.socialMedia.account.page,
        method: "post-json",
        sequence: true,
        cols: [
          { title: window.$t("txmis.socialMedia.common.id"), field: "id", hidden: true },
          { title: window.$t("txmis.socialMedia.account.table.sort"), field: "sort" },
          { title: window.$t("txmis.socialMedia.account.table.platform"), field: "platform", render:(data, full) => {
              return data ? data.platform : window.$t("txmis.socialMedia.common.undefined");
          } },
          { title: window.$t("txmis.socialMedia.account.table.url"), field: "url" },
          { title: window.$t("txmis.socialMedia.account.table.web"), field: "channels", render:(data, full) => {
              return data ? Array.from(data).filter(el => el.system === "WEB").map(el => el.channel).join() :
                window.$t("txmis.socialMedia.common.empty");
          } },
          { title: window.$t("txmis.socialMedia.account.table.m"), field: "channels", render:(data, full) => {
              return data ? Array.from(data).filter(el => el.system === "M").map(el => el.channel).join() :
                window.$t("txmis.socialMedia.common.empty");
            } },
          { title: window.$t("txmis.socialMedia.account.table.app"), field: "channels", render:(data, full) => {
              return data ? Array.from(data).filter(el => el.system === "APP").map(el => el.channel).join() :
                window.$t("txmis.socialMedia.common.empty");
            } },
          { title: window.$t("txmis.socialMedia.account.table.status"), field: "isActive", render:(data, full) => {
              return data ? window.$t("txmis.bt.enable") : window.$t("txmis.bt.disable");
            } },
          { title: window.$t("txmis.socialMedia.common.createdAt"), field: "createdAt" },
          { title: window.$t("txmis.socialMedia.common.updatedAt"), field: "updatedAt", render:(data, full) => {
               return data ? data : "";
            } },
          { title: window.$t("txmis.bt.operation"), btnClick: [
              { name: (data, row) => {
                  if(row.isActive === true) return window.$t("txmis.bt.disable");
                  if (row.isActive === false) return window.$t("txmis.bt.enable");
                }, field: "isActive", size: "mini", click: "activate", type: "primary", icon: "el-icon-edit" },
              { name: window.$t("txmis.bt.edit"), size: "mini", click: "update", type: "primary", icon: "el-icon-edit" },
              { name: window.$t("txmis.bt.delete"), size: "mini", click: "delete", type: "danger", icon: "el-icon-delete" }
            ]
          }
        ]
      },
      // Add/Update modal
      updateData: {
        cols: [
          { title: window.$t("txmis.socialMedia.common.id"), field: "id", hidden: true},
          { title: window.$t("txmis.socialMedia.account.modal.platform.label"), field: "platform", require: true, type: 2, optionList: [],
            placeholder: window.$t("txmis.socialMedia.account.modal.platform.placeholder") },
          { title: window.$t("txmis.socialMedia.account.modal.url.label"), field: "url", require:true, type: 1,
            placeholder: window.$t("txmis.socialMedia.account.modal.url.placeholder") },
          { title: window.$t("txmis.socialMedia.account.modal.web.label"), field: "webChannel", type: 4, data:[], optionList: [] },
          { title: window.$t("txmis.socialMedia.account.modal.m.label"), field: "mChannel", type: 4, data:[], optionList: [] },
          { title: window.$t("txmis.socialMedia.account.modal.app.label"), field: "appChannel", type: 4, data:[], optionList: [] },
          { title: window.$t("txmis.socialMedia.account.modal.sort.label"), field: "sort", type: 7, min: 0,
            placeholder: window.$t("txmis.socialMedia.account.modal.sort.placeholder") },
          { title: window.$t("txmis.socialMedia.account.modal.status.label"), field: "isActive", hidden: true},
        ]
      }
    }
  }
}

</script>

<style scoped>

</style>
